import React, { useEffect, useState } from 'react';
import SupervisorBankSearchModal from './SupervisorBankSearchModal';
import { resolveSupervisorBankById } from '../utils/supervisorLookup';
import { labelWithSeq } from './ScopeField';

/**
 * Champ "id banque" reutilisable cote superviseur, meme comportement que
 * LotteryCodeField.jsx (demande explicite 2026-09-17 : "pourquoi les champs
 * de bank... y a pas de unfocus sur eux meme facon que ceux des lotterie") :
 *   - input numerique ;
 *   - onFocus selectionne le contenu ;
 *   - onBlur resout l'id tape en nom (via utils/supervisorLookup, deja
 *     restreint a SES banks cote backend) et l'affiche a cote ; "Banque
 *     introuvable" en rouge sinon ;
 *   - bouton 🔍 -> SupervisorBankSearchModal.
 * La page garde la source de verite : passe `value`/`name`, recoit
 * `onChange(id)` (frappe) + `onResolve(id, name)` (blur / modal).
 */
export default function SupervisorBankCodeField({
  value,
  name = '',
  onChange,
  onResolve,
  inputClass = '',
  iconClass = '',
  nameClass = '',
  errClass = '',
  placeholder,
}) {
  const [err, setErr] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  // Texte AFFICHE (le numero seq tape/choisi) distinct de `value` (l'id interne
  // renvoye a la page via onResolve) — avant, la case affichait `value`, donc
  // l'id interne apres resolution, et un 2e blur relisait cet id comme un seq
  // (-> "introuvable" ou, pire, un AUTRE element). Corrige 2026-09-24.
  const [text, setText] = useState('');

  // La page a vide la valeur (changement de filtre...) -> vide aussi la case.
  useEffect(() => { if (!value) setText(''); }, [value]);

  const resolve = async () => {
    const c = String(text ?? '').trim();
    if (c === '') { setErr(''); return; }
    const r = await resolveSupervisorBankById(c);
    if (r) { onResolve(r.id, r.name); setErr(''); } else { setErr('Banque introuvable'); }
  };

  return (
    <>
      <input
        className={inputClass}
        type="text"
        inputMode="numeric"
        value={text}
        placeholder={placeholder}
        onChange={(e) => { setText(e.target.value); onChange(e.target.value); setErr(''); }}
        onFocus={(e) => e.target.select()}
        onBlur={resolve}
      />
      <span className={iconClass} onClick={() => setModalOpen(true)}>🔍</span>
      {err
        ? <span className={errClass || nameClass} style={{ color: '#c0392b' }}>{err}</span>
        : (name ? <span className={nameClass}>{name}</span> : null)}
      {modalOpen && (
        <SupervisorBankSearchModal
          onSelect={(id, nm, _username, seq) => { setText(seq != null ? String(seq) : ''); onResolve(String(id), labelWithSeq(seq, nm)); setErr(''); }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
